import React from 'react'

const PlayerContext = React.createContext({
    seconds: 0,
    setSeconds: () => {}
  })

export const PlayerProvider = PlayerContext.Provider
export const PlayerConsumer = PlayerContext.Consumer
export default PlayerContext